module.exports = __webpack_public_path__ + "static/img/line_bj.31fdc1ea.png";